
document.querySelectorAll('.reveal').forEach(el=>{
const o=new IntersectionObserver(e=>{
e.forEach(x=>{if(x.isIntersecting)x.target.classList.add('visible')})
},{threshold:.2});
o.observe(el);
});

const canvas=document.getElementById('hero-particles');
if(canvas){
const ctx=canvas.getContext('2d');
function resize(){canvas.width=window.innerWidth;canvas.height=window.innerHeight}
resize();window.addEventListener('resize',resize);
const pts=[];
for(let i=0;i<60;i++)pts.push({x:Math.random()*canvas.width,y:Math.random()*canvas.height,vx:(Math.random()-.5)*.4,vy:(Math.random()-.5)*.4,r:Math.random()*2});
function anim(){
ctx.clearRect(0,0,canvas.width,canvas.height);
pts.forEach(p=>{
p.x+=p.vx;p.y+=p.vy;
if(p.x<0||p.x>canvas.width)p.vx*=-1;
if(p.y<0||p.y>canvas.height)p.vy*=-1;
ctx.beginPath();
ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
ctx.fillStyle='rgba(200,196,188,.35)';
ctx.fill();
});
requestAnimationFrame(anim);
}
anim();
}

/* Custom Cursor */
const cursor=document.createElement('div');
cursor.id='cursor';
document.body.appendChild(cursor);

const ring=document.createElement('div');
ring.id='cursor-ring';
document.body.appendChild(ring);

let mx=window.innerWidth/2;
let my=window.innerHeight/2;
let rx=mx;
let ry=my;

document.addEventListener('mousemove',e=>{
  mx=e.clientX;
  my=e.clientY;
});

function animateCursor(){
  rx += (mx-rx)*0.14;
  ry += (my-ry)*0.14;

  cursor.style.left=mx+'px';
  cursor.style.top=my+'px';

  ring.style.left=rx+'px';
  ring.style.top=ry+'px';

  requestAnimationFrame(animateCursor);
}
animateCursor();

/* Hover enlarge */
document.querySelectorAll('a,button').forEach(el=>{
  el.addEventListener('mouseenter',()=>{
    ring.style.width='56px';
    ring.style.height='56px';
  });

  el.addEventListener('mouseleave',()=>{
    ring.style.width='36px';
    ring.style.height='36px';
  });
});

/* Counter Animation */
const counters=document.querySelectorAll('.counter');

const counterObserver=new IntersectionObserver(entries=>{
  entries.forEach(entry=>{
    if(!entry.isIntersecting) return;

    const el=entry.target;
    const target=parseInt(el.dataset.target);

    let count=0;
    const increment=target/100;

    const timer=setInterval(()=>{
      count += increment;

      if(count >= target){
        count = target;
        clearInterval(timer);
      }

      el.textContent=Math.floor(count);
    },16);

    counterObserver.unobserve(el);
  });
},{threshold:.5});

counters.forEach(c=>counterObserver.observe(c));
